import { IHttpApi } from '@cian/http-api';
import { ISearchCatalogItemSchema } from '../../repositories/monolith-python/entities/schemas/SearchCatalogItemSchema';
import {
  fetchCianApiSiteV1GetRegionCities,
  TCianApiSiteV1GetRegionCitiesResponse,
} from '../../repositories/monolith-python/cian-api/site/v1/get-region-cities';

export function getRegionCities(
  httpApi: IHttpApi,
  regionId: number,
  subdomain: string,
): Promise<TCianApiSiteV1GetRegionCitiesResponse> {
  return fetchCianApiSiteV1GetRegionCities({ httpApi, parameters: { regionId }, config: { subdomain } });
}

export async function resolveRegionCities(
  httpApi: IHttpApi,
  regionId: number,
  subdomain: string,
): Promise<ISearchCatalogItemSchema[]> {
  const getResponse = await getRegionCities(httpApi, regionId, subdomain);
  if (getResponse.statusCode === 200) {
    return getResponse.response.data.items as ISearchCatalogItemSchema[];
  }

  return [] as ISearchCatalogItemSchema[];
}
